// extracted by mini-css-extract-plugin
export default {"actionButtons":"operatorTable_actionButtons__9eUAH","closingBalance":"operatorTable_closingBalance__PKIRR","alignRight":"operatorTable_alignRight__Kz3Pj"};